'use client';

/**
 * SysObeyaKpiCohesionHighCard — Procedural Patterns KPI tile.
 *
 * Slices `response.totals.high_procedural_count` +
 * `response.config.minimum_score` from the system_obeya_view cohesion
 * call. Hero number is the count at/above the threshold; sub-label
 * shows the threshold itself ("≥ 0.6").
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_cohesion_high"
 * @see klyde_edge/ui_config/labels/system_obeya.py — cohesion_kpi_high_*
 */

import { AlertTriangle } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiCohesionHighCard({ view_name = 'cohesion' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  const c = data?.config ?? {};
  const threshold = c.minimum_score;
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_cohesion_high"
      label={L.cohesion_kpi_high_label ?? ''}
      Icon={AlertTriangle}
      value={isLoading ? '…' : fmt(t.high_procedural_count)}
      sub={threshold != null ? `${L.cohesion_kpi_high_sub_prefix ?? ''}${threshold}` : undefined}
      queryKey={queryKey}
    />
  );
}
